import React from "react";

const InfoBlock = () => {
    return (
        <section>
            <p>
                <strong>Uwaga!</strong>
            </p>
            <p>
                Zgłoszenie do Konkursu Dyrektor e-Commerce Roku 2021 łączy się z obowiązkiem uiszczenia opłaty w
                wysokości:
            </p>
            <ol>
                <li>
                    Członkowie i partnerzy Organizatora w rozumieniu jego statutu:
                    <ul>
                        <li>zgłoszenie do 31.05.2021 - 1499 zł netto za każde zgłoszenie w danej Kategorii.</li>
                        <li>zgłoszenie od 1.06.2021 - 2199 zł netto za zgłoszenia w danej Kategorii.</li>
                    </ul>
                </li>
                <li>
                    Podmioty nie będące członkami/partnerami Organizatora, zgłaszające się do Konkursu:
                    <ul>
                        <li>zgłoszenie do 31.05.2021 - 2499 zł netto za każde zgłoszenie w danej Kategorii.</li>
                        <li>zgłoszenie od 1.06.2021 - 3699 zł netto za każde zgłoszenie w danej Kategorii.</li>
                    </ul>
                </li>
            </ol>
            <p>
                Kwoty powiększone o należny podatek VAT należy wnosić na rachunek bankowy Organizatora prowadzony przez
                Bank (PKO BP SA Oddział 1 w Warszawie) o numerze <strong>79 1020 1013 0000 0302 0291 6963</strong>.
            </p>
        </section>
    );
};

export default InfoBlock;
